export default __webpack_public_path__ + "static/media/port1.110151e6.png";